import { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router';
import { Button } from './ui/button';
import { Avatar, AvatarFallback } from './ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from './ui/alert-dialog';
import { useAuth } from '../contexts/AuthContext';
import { IUserInfo } from '../model/user';
import { useSidebar } from './ui/sidebar';

interface NavigationProps {
  userPoints: number;
  userInfo: IUserInfo | null;
  onOpenPointsDialog: () => void;
  onShowLogin: () => void;
  logout: () => void;
}

export function Navigation({
  userPoints,
  onOpenPointsDialog,
  onShowLogin,
  logout,
  userInfo,
}: NavigationProps) {
  // const { user, isAuthenticated, logout } = useAuth();
  const [showLogoutDialog, setShowLogoutDialog] = useState(false);
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const { state } = useSidebar();
  const isCollapsed = state === 'collapsed';
  // 监听滚动事件 - 延迟到接近标题时才变白
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const getUserInitial = () => {
    if (userInfo?.email) {
      return userInfo.email.charAt(0).toUpperCase();
    }
    return 'U';
  };

  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path !== '/' && location.pathname.startsWith(path)) return true;
    return false;
  };

  const handleLogoutClick = () => {
    setShowLogoutDialog(true);
  };

  const handleConfirmLogout = () => {
    setShowLogoutDialog(false);
    logout();
    navigate('/');
  };

  return (
    <nav
      className={`fixed top-0 right-0 h-16 z-110 transition-[left,background-color] duration-200 ${
        (!isScrolled && isActive('/')) || userInfo
          ? 'bg-transparent border-transparent'
          : 'bg-white/90 backdrop-blur-md border-b border-border'
      } ${isCollapsed ? 'left-0 md:left-16' : 'left-0 md:left-64'}`}
    >
      {/* // <nav
    //   className={`fixed top-0 left-0 right-0 px-18 z-50 transition-all duration-300 ${
    //     !isScrolled && isActive('/')
    //       ? 'bg-transparent'
    //       : 'bg-white border-b border-border'
    //   }`}
    // > */}
      {/* <div className="max-w-[1440px] mx-auto h-16 flex items-center justify-between">
        <div className="flex items-center" style={{ gap: '32px' }}>
          <Link
            to="/"
            className={`py-2 transition-all text-base ${
              isActive('/')
                ? 'text-black font-alipuhui-b'
                : 'text-black/60 hover:text-black font-alipuhui-r'
            }`}
          >
            Home
          </Link>
          <Link
            to="/my-clips"
            className={`py-2 transition-all text-base ${
              isActive('/my-clips')
                ? 'text-black font-alipuhui-b'
                : 'text-black/60 hover:text-black font-alipuhui-r'
            }`}
          >
            My Clips
          </Link>
          <Link
            to="/explore"
            className={`py-2 transition-all text-base ${
              isActive('/explore')
                ? 'text-black font-alipuhui-b'
                : 'text-black/60 hover:text-black font-alipuhui-r'
            }`}
          >
            Explore
          </Link>
        </div>

        <Link
          to="/"
          className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2 hover:scale-105 transition-transform"
        >
          <img
            src="https://cdn.jumpstar.app/solve/ai_gen/20251202/7847876a-bcf8-479b-81a9-aef69c5dd7bd.png"
            alt="SolveClip Logo"
            className="object-contain"
            style={{
              height: '30px',
              maxHeight: '30px',
            }}
          />
        </Link>

        <div className="flex items-center gap-3">
          {userInfo ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button className="focus:outline-none">
                  <Avatar className="h-10 w-10 cursor-pointer hover:opacity-80 transition-opacity border-0">
                    <AvatarFallback
                      className="text-base font-normal"
                      style={{ backgroundColor: '#000000', color: '#FFE75C' }}
                    >
                      {getUserInitial()}
                    </AvatarFallback>
                  </Avatar>
                </button>
              </DropdownMenuTrigger>
              <DropdownMenuContent
                align="end"
                className="border border-[rgba(0,0,0,0.08)] p-0! overflow-hidden! bg-white rounded-[20px]! w-[294px]! h-[220px]! min-w-[294px]! max-w-[294px]! min-h-[220px]! max-h-[220px]!"
              >
                <div className="flex flex-col items-center pt-6 pb-6">
                  <Avatar className="h-16 w-16 mb-4">
                    <AvatarFallback
                      className="text-2xl font-normal"
                      style={{ backgroundColor: '#000000', color: '#FFE75C' }}
                    >
                      {getUserInitial()}
                    </AvatarFallback>
                  </Avatar>
                  <a
                    href={`mailto:${userInfo?.email}`}
                    className="text-[18px] text-black hover:underline"
                  >
                    {userInfo?.email}
                  </a>
                </div>

                <div className="flex justify-center py-1">
                  <div
                    style={{
                      width: '249px',
                      height: '1px',
                      backgroundColor: 'rgba(0, 0, 0, 0.1)',
                    }}
                  />
                </div>

                <div className="flex items-center" style={{ height: '50px' }}>
                  <button
                    onClick={handleLogoutClick}
                    className="w-full text-center text-[18px] font-semibold cursor-pointer transition-colors text-black"
                    style={{
                      fontFamily: 'PingFang SC, sans-serif',
                      fontWeight: 600,
                    }}
                  >
                    Log out
                  </button>
                </div>
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <Button
              onClick={onShowLogin}
              className="rounded-full h-10 px-6 bg-black hover:bg-black/90 text-white"
            >
              Login
            </Button>
          )}
        </div>
      </div> */}

      <div className="max-w-[1296px] mx-auto h-16 flex items-center justify-end px-6 md:px-10">
        {!userInfo && (
          <Button
            onClick={onShowLogin}
            className="h-[34px] px-6 bg-black text-white text-sm rounded-full hover:bg-black/90 transition-colors shrink-0 whitespace-nowrap"
          >
            Login
          </Button>
        )}
      </div>

      {/* Logout Confirmation Dialog */}
      <AlertDialog open={showLogoutDialog} onOpenChange={setShowLogoutDialog}>
        <AlertDialogContent
          className="border! border-[rgba(0,0,0,0.08)]! p-[25px]! max-w-[536px]! gap-4"
          style={{
            borderRadius: '20px',
            borderTopLeftRadius: '20px',
            borderTopRightRadius: '20px',
            borderBottomLeftRadius: '20px',
            borderBottomRightRadius: '20px',
            overflow: 'hidden',
          }}
        >
          <AlertDialogHeader className="space-y-2!">
            <AlertDialogTitle
              className="font-semibold! tracking-[-0.4395px]! text-black"
              style={{
                fontFamily: 'Inter, sans-serif',
                lineHeight: '28px',
                fontSize: '18px',
                fontWeight: 600,
              }}
            >
              Are you sure you want to log out?
            </AlertDialogTitle>
            <AlertDialogDescription
              className="tracking-[-0.1504px]!"
              style={{
                color: '#666666',
                fontFamily: 'Inter, sans-serif',
                lineHeight: '20px',
                fontSize: '14px',
                fontWeight: 400,
              }}
            >
              You will not be able to see the generated learning videos.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter className="gap-2! flex-row! justify-end!">
            <AlertDialogCancel
              className="rounded-full! h-9! px-[17px]! border! border-[rgba(0,0,0,0.08)]! text-[14px]! font-medium! tracking-[-0.1504px]! opacity-100!"
              style={{
                fontFamily: 'Inter, sans-serif',
                backgroundColor: '#FFFFFF',
                color: '#000000',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#000000';
                e.currentTarget.style.color = '#FFFFFF';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#FFFFFF';
                e.currentTarget.style.color = '#000000';
              }}
            >
              Cancel
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={handleConfirmLogout}
              className="rounded-full! h-9! px-4! text-[14px]! font-medium! tracking-[-0.1504px]! opacity-100!"
              style={{
                fontFamily: 'Inter, sans-serif',
                backgroundColor: '#FFFFFF',
                color: '#000000',
                border: '1px solid rgba(0, 0, 0, 0.08)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#000000';
                e.currentTarget.style.color = '#FFFFFF';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#FFFFFF';
                e.currentTarget.style.color = '#000000';
              }}
            >
              Log out
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </nav>
  );
}
